import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const NewDepManagerAssignmentNotificationCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? 'تعيين مدير جديد للقسم'
          : 'New manager has been assigned to your department'
      }
    />
  )
}

export default NewDepManagerAssignmentNotificationCover
